export const CONSIGNMENT_CREDIT_OVERRIDE = 'OVERRIDE';
export const CONSIGNMENT_CREDIT_REJECTED = 'REJECTED';
export const CONSIGNMENT_CREDIT_FAILED = 'FAILED';
export const CONSIGNMENT_CREDIT_PASSED = 'PASSED';
export const CONSIGNMENT_CREDIT_CAPTURE = 'CAPTURE';